import { render } from "./ITStartupPage.vue?vue&type=template&id=ddeef762&scoped=true"
import script from "./ITStartupPage.vue?vue&type=script&lang=js"
export * from "./ITStartupPage.vue?vue&type=script&lang=js"

import "./ITStartupPage.vue?vue&type=style&index=0&id=ddeef762&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddeef762"]])

export default __exports__